import React from 'react';

import AdminLogin from '../components/AdminLogin';

function AdminLoginPage(){
    return (
        <AdminLogin title={'Admin'}/>
    )
}
export default AdminLoginPage;